import { getApps, initializeApp } from "firebase/app"
import {
  ReCaptchaV3Provider,
  getToken,
  initializeAppCheck,
} from "firebase/app-check"

let appCheckInstance = null
let initPromise = null

const isFirebaseConfigured = () =>
  Boolean(
    import.meta.env.VITE_FIREBASE_PROJECT_ID &&
      import.meta.env.VITE_FIREBASE_APP_ID &&
      import.meta.env.VITE_FIREBASE_API_KEY
  )

export const initFirebase = () => {
  if (initPromise) {
    return initPromise
  }

  initPromise = (async () => {
    if (!isFirebaseConfigured()) {
      console.warn(
        "Firebase App Check skipped: set VITE_FIREBASE_* env vars to enable"
      )
      return null
    }

    const recaptchaSiteKey = import.meta.env.VITE_FIREBASE_APPCHECK_RECAPTCHA_SITE_KEY
    if (!recaptchaSiteKey) {
      console.warn(
        "Firebase App Check skipped: VITE_FIREBASE_APPCHECK_RECAPTCHA_SITE_KEY not set"
      )
      return null
    }

    const firebaseConfig = {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
    }

    const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

    if (import.meta.env.DEV && import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN) {
      globalThis.FIREBASE_APPCHECK_DEBUG_TOKEN =
        import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN
    }

    appCheckInstance = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    })

    return appCheckInstance
  })()

  return initPromise
}

export const getAppCheckToken = async (forceRefresh = false) => {
  await initFirebase()
  if (!appCheckInstance) {
    return null
  }

  const { token } = await getToken(appCheckInstance, forceRefresh)
  return token
}

export const isAppCheckEnabled = () => isFirebaseConfigured()
